const STORAGE_KEY = 'drawerPanels';
const DEFAULT_VALUE = window.innerWidth < 640;
export function drawerPanelsEnabled(context) {
    const storage = context.getMethodsOf('storage');
    const open = storage.getItem(STORAGE_KEY);
    return typeof open === 'boolean' ? open : DEFAULT_VALUE;
}
export function setDrawerPanels(context, enabled) {
    const storage = context.getMethodsOf('storage');
    storage.setItem(STORAGE_KEY, enabled);
}
